// extracted by mini-css-extract-plugin
export var cardIcon = "_65-5";
export var checkboxCard = "_65-0";
export var checkboxCardSelected = "_65-4";
export var disabled = "_65-2";
export var interactive = "_65-1";
export var outerBorder = "_65-3";
export var spacerMedium = "_65-8";
export var spacerSmall = "_65-7";
export var spacerXsmall = "_65-6";